export const labTime: number = 100
export const theoryTime: number = 50
